import i18n from '@/i18n';
import tarjetaIcon from '@/assets/icons/raw/tarjeta.svg';
import ordenarIcon from '@/assets/icons/raw/ordenar.svg';
import monedasIcon from '@/assets/icons/raw/monedas.svg';
import tarjetaCheckIcon from '@/assets/icons/raw/tarjeta-check.svg';
import depositoIcon from '@/assets/icons/raw/deposito.svg';
import bizumIcon from '@/assets/img/bizum.png';

export const TIPOS_PASARELAS_PAGO = {
  TPV: 'TPV',
  TRANSFERENCIA_MANUAL: 'TRANSFERENCIA_MANUAL',
  INESPAY: 'INESPAY',
  EFECTIVO: 'EFECTIVO',
};

export const CATEGORIAS_PASARELAS_SALDO = {
  CREDITO: 'credito',
  DEPOSITO: 'deposito',
};

export const CATEGORIAS_PASARELAS_CON_SALDO = Object.values(CATEGORIAS_PASARELAS_SALDO);

const CATEGORIAS_PASARELAS_PAGO = {
  tpv: {
    icon: tarjetaIcon,
    i18nKey: 'reserva.pagoTPV',
    i18nKeyMobile: 'reserva.pagoTPVMobile',
  },
  bizum: {
    icon: bizumIcon,
    i18nKey: 'reserva.pagoBizum',
    i18nKeyMobile: 'reserva.pagoBizumMobile',
  },
  transferencia: {
    icon: ordenarIcon,
    i18nKey: 'reserva.pagoTransferencia',
    i18nKeyMobile: 'reserva.pagoTransferenciaMobile',
  },
  efectivo: {
    icon: monedasIcon,
    i18nKey: 'reserva.pagoEfectivo',
    i18nKeyMobile: 'reserva.pagoEfectivoMobile',
  },
  credito: {
    icon: tarjetaCheckIcon,
    i18nKey: 'reserva.pagoCredito',
    i18nKeyMobile: 'reserva.pagoCreditoMobile',
  },
  deposito: {
    icon: depositoIcon,
    i18nKey: 'reserva.pagoDeposito',
    i18nKeyMobile: 'reserva.pagoDepositoMobile',
  },
};

export function normalizePasarelasPago(pasarelasPago) {
  const { t } = i18n.global;
  const listPasarelasPago = [];

  ['tpv', 'bizum', 'transferencia', 'efectivo', 'credito', 'deposito'].forEach(categoria => {
    const items = pasarelasPago?.[categoria];
    if (!items) return;
    items.forEach(item => {
      listPasarelasPago.push({
        id: item.id,
        titulo: t(CATEGORIAS_PASARELAS_PAGO[categoria].i18nKey),
        tituloMobile: t(CATEGORIAS_PASARELAS_PAGO[categoria].i18nKeyMobile),
        nombre: item.nombre,
        icon: CATEGORIAS_PASARELAS_PAGO[categoria].icon,
        refundEnabled: item.refundEnabled,
        cuposIntegradosPermitidos: item.cuposIntegradosPermitidos,
        categoria,
      });
    });
  });

  return listPasarelasPago;
}
